import { useContext } from "react";
import { ProjectOverviewContext } from "@/projectOverview/projectOverviewContextValue";

export function useProjectOverview() {
  const ctx = useContext(ProjectOverviewContext);
  if (!ctx) {
    throw new Error("useProjectOverview must be used within ProjectOverviewProvider");
  }
  return ctx;
}
